import styles from "./list.module.css";

const SKELETON_COLUMNS = 7;

const BookingSkeleton = ({ rows = 6 }) => {
    const rowArray = Array.from({ length: rows });

    return (<div className={`${styles.SkeletonWrap}`} role="status" aria-live="polite" aria-label="Loading bookings">
        <div className={`${styles.SkeletonToolbar}`}>
            <div className={`${styles.SkeletonBar} ${styles.SkeletonSearch}`} />
            <div className={`${styles.SkeletonToolbarBUSec}`}>
                <div className={`${styles.SkeletonBar} ${styles.SkeletonBU}`} />
                <div className={`${styles.SkeletonBar} ${styles.SkeletonBU}`} />
            </div>
        </div>

        {/* Desktop table skeleton */}
        <div className={`${styles.SkeletonTable}`}>
            <div className={`${styles.SkeletonTableHeadRow}`}>
                {Array.from({ length: SKELETON_COLUMNS }).map((_, i) => (
                    <div className={`${styles.SkeletonBar} ${styles.SkeletonHeadBar}`} key={i} />
                ))}
            </div>
            {rowArray.map((_, r) => (
                <div className={`${styles.SkeletonTableRow}`} key={r}>
                    {Array.from({ length: SKELETON_COLUMNS }).map((_, c) => (
                        <div className={`${styles.SkeletonBar} ${styles.SkeletonCellBar}`} key={c} />
                    ))}
                </div>
            ))}
        </div>

        {/* Mobile card skeleton — mirrors .ResponsiveRow */}
        <div className={`${styles.SkeletonCardList}`}>
            {rowArray.map((_, r) => (
                <div className={`${styles.SkeletonCard}`} key={r}>
                    <div className={`${styles.SkeletonCheckboxDot}`} />
                    {Array.from({ length: 5 }).map((_, c) => (
                        <div className={`${styles.SkeletonCardRow}`} key={c}>
                            <div className={`${styles.SkeletonBar} ${styles.SkeletonLabelBar}`} />
                            <div className={`${styles.SkeletonBar} ${styles.SkeletonValueBar}`} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    </div>);
};

export default BookingSkeleton;